import { QUESTION, SURVEY } from '../../constants/terminology';
import { RoutesInterface } from '../../types/routes';

export const statsRoutes: RoutesInterface = {
  STATS: {
    id: 'stats_root',
    label: 'Home',
    tooltip: 'Statistics',
    path: '/stats/',
    icon: 'fa-folder-open',
    exact: false,
    auth: true,
  },
  STATS_COMPANIES: {
    id: 'stats_companies',
    label: 'Companies',
    tooltip: 'Company Statistics',
    path: '/stats/company',
    icon: 'fa-folder-open',
    exact: false,
    auth: true,
  },
  STATS_SURVEY: {
    id: 'stats_survey',
    label: SURVEY.CAPITALIZED_PLURAL,
    tooltip: `${SURVEY.CAPITALIZED_SINGULAR} Statistics`,
    path: '/stats/survey',
    icon: 'fa-folder-open',
    exact: true,
    auth: true,
  },
  STATS_SCOPE: {
    id: 'stats_scope',
    label: 'Scopes',
    tooltip: `${SURVEY.CAPITALIZED_SINGULAR} Scope Statistics`,
    path: '/stats/scope/:scopeType?',
    icon: 'fa-folder-open',
    exact: true,
    auth: true,
  },
  STATS_STANDARDS: {
    id: 'stats_standards',
    label: 'Standards',
    tooltip: 'Standards Statistics',
    path: '/stats/standards',
    icon: 'fa-folder-open',
    exact: true,
    auth: true,
  },
  STATS_QUESTIONS: {
    id: 'stats_questions',
    label: QUESTION.CAPITALIZED_PLURAL,
    tooltip: `${QUESTION.CAPITALIZED_PLURAL} Statistics`,
    path: '/stats/questions',
    icon: 'fa-folder-open',
    exact: true,
    auth: true,
  },
}
